"use client";

import NextLink from "next/link";
import React from "react";
import SharedBaseButton, {
  type BaseButtonProps,
  type ButtonLinkProps,
} from "@repo/ui/library/base-button";
import { useOrg } from "@/hooks/useOrg";

export type { BaseButtonProps, BaseButtonType } from "@repo/ui/library/base-button";

const AppLink = React.forwardRef<HTMLAnchorElement, ButtonLinkProps>(
  function AppLink({ href, prefetch, ...props }, ref) {
    return <NextLink ref={ref} href={href} prefetch={prefetch} {...props} />;
  }
);

const BaseButton = React.forwardRef<HTMLButtonElement | HTMLAnchorElement, BaseButtonProps>(
  function BaseButton(props, ref) {
    const org = useOrg();
    return (
      <SharedBaseButton
        {...props}
        ref={ref}
        brand={org?.ui?.brand}
        devChecks={process.env.NEXT_PUBLIC_ENVIRONMENT === "development"}
        linkComponent={AppLink}
      />
    );
  }
);

BaseButton.displayName = "BaseButton";

export default BaseButton;
